import request from '@/utils/request'

export function getWorkshopList(data) {
  return request.post('/workshop/list', data)
}

export function addWorkshop(data) {
  return request.post('/workshop/add', data)
}

export function modifyWorkshop(data) {
  return request.post('/workshop/modify', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/workshop.js